/* istanbul ignore file */
export enum PatchTypes {
    Remove = 'Remove',
    AddUpdate = 'AddUpdate',
}
